module.exports = __webpack_public_path__ + "img/ieo-img-3.f2d00009.jpg";